import RecapVideo from 'components/recap-video'
import textServices from 'services/text-services'
import { AFTERWORK_ASSETS, AFTERWORK_VIDEOS } from '../constants'

// Recap of the last edition (Figma 43:101 desktop, 6033:8530 mobile). The
// header copy sits on solid green; on mobile the 4:5 clip is a full-width
// block below it with the gradient fusing over its top edge, while from
// 768px the 16:9 footage fills the whole section behind the copy.
const ReviveSection = () => {
  return (
    <section className="afterwork__revive">
      <div className="afterwork__revive-content">
        <h2 className="afterwork__revive-title">
          {textServices.findByText('afterwork/revive/title', 'Revive la experiencia')}
        </h2>
        <p className="afterwork__revive-description">
          {textServices.findByText(
            'afterwork/revive/description',
            'Así se vivieron los mejores momentos de Afterwork MTY 2026. Prepárate para la próxima edición.'
          )}
        </p>
      </div>
      <div className="afterwork__revive-media">
        <RecapVideo
          className="afterwork__revive-video"
          mobileSrc={`${AFTERWORK_ASSETS}/${AFTERWORK_VIDEOS.recap.mobile}`}
          desktopSrc={`${AFTERWORK_ASSETS}/${AFTERWORK_VIDEOS.recap.desktop}`}
          trackSection="afterwork"
        />
        <div className="afterwork__revive-overlay" aria-hidden="true" />
      </div>
    </section>
  )
}

export default ReviveSection
